import { create } from "zustand"

type Types = "info" | "warning" | "error" | "success"

type Message = {
    text: string
    index: number
    type: Types
}

type MessageApi = {
    messages: Message[]
    create: (type: Types, messages: string, timeout?: number) => void
}
let index = 0
export const useMessages = create<MessageApi>((set) => ({
    messages: [],
    create: (type: Types, message: string, timeout: number = 4000) => {
        const ind = index++
        set((s) => ({ messages: [...s.messages, { text: message, type, index: ind }] }))
        setTimeout(() => {
            set((s) => ({ messages: s.messages.filter((i) => i.index !== ind) }))
        }, timeout)
    }
}))

type GlobalFn = (msg: string, timeout?: number) => void

export const message: Record<Types, GlobalFn> = {
    get info() {
        return useMessages.getState().create.bind(null, "info")
    },
    get warning() {
        return useMessages.getState().create.bind(null, "warning")
    },
    get success() {
        return useMessages.getState().create.bind(null, "success")
    },
    get error() {
        return useMessages.getState().create.bind(null, "error")
    }
}
